import {
  GETALL_USUARIOS,
  ACTIVO_USUARIOS,
  SET_LOGOUT,
  BY_IDENTIFICACION_USUARIOS,
  CLEAR_ALL,
  PARAMS_USUARIOS,
  LOADING_GETALL_USUARIOS,
  SEARCH_USERS,
  SEARCH_USER_CODES,
} from '../../store/Types';

const initialState = {
  all: [],
  loadingGetAll: false,
  meta: null,
  links: null,
  activo: null,
  params: {
    entityId: null,
    sort: null,
    sortDirection: null,
    page: null,
    limit: null,
  },
  userByIdentificacion: null,
  searchUsers: [],
  searchUserCodes: [],
};

export const usuariosReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_USUARIOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_GETALL_USUARIOS:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case ACTIVO_USUARIOS:
      return {
        ...state,
        activo: action.payload,
      };
    case SET_LOGOUT || CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case BY_IDENTIFICACION_USUARIOS:
      return {
        ...state,
        userByIdentificacion: action.payload,
      };
    case PARAMS_USUARIOS:
      return {
        ...state,
        params: action.payload,
      };
    case SEARCH_USERS:
      return {
        ...state,
        searchUsers: action.payload,
      };
    case SEARCH_USER_CODES:
      return {
        ...state,
        searchUserCodes: action.payload,
      };
    default:
      return state;
  }
};
